import {
  OPT_TASKS_LIST_TYPE_ALL_VALUE,
  OPT_TASKS_LIST_STATUS_ALL_VALUE
} from 'Constants/'
import { atom, atomFamily } from 'recoil'

export const searchState = atom({
  key: 'TasksListSearchState',
  default: {
    searchText: '',
    isEnabled: OPT_TASKS_LIST_STATUS_ALL_VALUE,
    action: OPT_TASKS_LIST_TYPE_ALL_VALUE,
    hide: false,
    tagIds: [],
    idMessages: undefined
  }
})

export const searchResult = atom({
  key: 'TasksListSearchResult',
  default: {
    items: undefined
  }
})

export const paginationState = atom({
  key: 'TasksListPaginationState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0
  }
})

export const tagsState = atom({
  key: 'TasksListTagsState',
  default: []
})

export const moreResults = atomFamily({
  key: 'TasksListMoreResults',
  default: {
    moreLoaded: false,
    moreLoading: false,
    moreMessageDetails: [],
    moreCountMessage: [],
    error: false,
    severity: 'danger',
    statusToggle: false
  }
})
